
import { useAuth } from "./AuthContext";
import { Navigate } from "react-router";


export const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
    const { isAuthenticated, loading } = useAuth()

    if (loading) {
        return null;
    }

    if (!isAuthenticated) {
        return <Navigate to={"/login"} replace />;
    }

    return (<>
        {children}
    </>)
}


// const PrivateRouteContext = createContext<PrivateRouteContextType>({})

// export const useAuth = () => {
//     const context = useContext(PrivateRouteContext)
//     if (!context) {
//         throw new Error("PrivateRouteContext must be inside it's context")
//     }
//     return context
// }

// export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {


//     return (
//         <PrivateRouteContext.Provider value={{}}>
//             {children}
//         </PrivateRouteContext.Provider>
//     )
// } 